import { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { logger } from 'services/logger'
import {
  AppErrorFallbackView,
  errorFallbackTheme,
} from 'components/AppErrorFallback/AppErrorFallback'

const SKEW_RELOAD_KEY = 'rootSkewReloadedAt'
const RELOAD_BACKOFF_MS = 30 * 1000

export function SkewRecovery() {
  useEffect(() => {
    const lastReload = Number(sessionStorage.getItem(SKEW_RELOAD_KEY) || 0)
    if (Date.now() - lastReload < RELOAD_BACKOFF_MS) return
    sessionStorage.setItem(SKEW_RELOAD_KEY, String(Date.now()))
    logger.info('Recovered from version skew (missing root data) - reloading')
    window.location.reload()
  }, [])

  return (
    <ThemeProvider theme={errorFallbackTheme}>
      <AppErrorFallbackView onTryAgain={() => window.location.reload()} />
    </ThemeProvider>
  )
}

export function RootErrorFallback() {
  return (
    <ThemeProvider theme={errorFallbackTheme}>
      <AppErrorFallbackView onTryAgain={() => window.location.reload()} />
    </ThemeProvider>
  )
}
